var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('el-image-viewer',{attrs:{"on-close":_vm.handleClose,"url-list":_vm.urlList,"z-index":_vm.zIndex}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }